import {Component, OnInit} from '@angular/core';
import {MethodsProvider} from '@providers/methods/methods.provider';
import {AbstractFields} from '../_abstract';
import {FormArray, FormBuilder} from '@angular/forms';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {WizardFormEventsService} from '../../services/wizard-form-groups-services/wizard-form-events.service';
import {ModelsInterfaces} from '@namespaces/models.namespace';
import Method = ModelsInterfaces.Method;

@Component({
    selector: 'app-attestation-method',
    templateUrl: './attestation-method.component.html'
})

export class AttestationMethodComponent extends AbstractFields implements OnInit {
    public availableMethods: {id: string, title: string, disabled: boolean}[] = [];

    public submethods: SelectableMethod[] = [];

    public showSubmethods = false;

    private methods: Method[] = [];

    constructor(
        private methodsProvider: MethodsProvider,
        private wizardFormEventsService: WizardFormEventsService,
        private fb: FormBuilder,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();

        this.methods = this.methodsProvider.data$.getValue().asTree;

        this.subs.push(
            this.wizardFormEventsService.attestationChange$.pipe(
                map((value) => value.map(v => v.key).filter(v => Boolean(v)))
            ).subscribe((shortTitles: string[]) => {
                this.setAvailableMethods(shortTitles);
            })
        );

        this.form.get('key').valueChanges.pipe(
            distinctUntilChanged()
        ).subscribe((shortTitle: string) => {
            this.restoreSubmethods();
        });

        this.form.get('key').updateValueAndValidity();
    }

    setAvailableMethods(selectedShortTitles: string[]) {
        this.availableMethods = this.methods.map(method => {
            return {
                id: method.short_title,
                title: method.title,
                disabled: selectedShortTitles.includes(method.short_title),
            };
        });
    }

    clearObjects() {
        const array = this.form.get('objects') as FormArray;

        while (array.length) {
            array.removeAt(0);
        }
    }

    setObjectsToForm(objects: any[]) {
        this.clearObjects();

        const array = this.form.get('objects') as FormArray;

        objects.forEach(item => {
            array.push(this.fb.group(item));
        });
    }

    onSubmethodChange() {
        const array = this.form.get('submethods') as FormArray;
        while (array.length) {
            array.removeAt(0);
        }

        this.submethods.filter(item => item.checked).forEach(item => {
            array.push(this.fb.group({
                id: item.id,
                title: item.title,
                parent_id: item.parent_id
            }));
        });
    }

    uncheckSubmethod(submethod: SelectableMethod) {
        submethod.checked = false;
        this.onSubmethodChange();
    }

    private restoreSubmethods() {
        const selectedMethod = this.methodsProvider.getByShortTitle(this.form.get('key').value);

        if (!selectedMethod || !selectedMethod.methods || !selectedMethod.methods.length) {
            this.submethods = [];
            return;
        }


        const array = this.form.get('submethods') as FormArray;
        const submethodsIds = array.value.map(v => +v.id);

        this.submethods = selectedMethod.methods.map(m => {
            return {
                checked: submethodsIds.includes(+m.id),
                ...m
            };
        });

        this.onSubmethodChange();
    }
}

interface SelectableMethod extends Method {
    checked: boolean;
}
